import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import PrivateRoutes from './components/Utilities/PrivateRoutes';
// import CloudExpenseGenerator from './pages/ExpenseAutomation/CloudExpenseGenerator';
// import FileList from './pages/FileDownload/FileList.js';
// import Dashboard from './pages/Home/Dashboard.js';
// import AuroraDashboard from './pages/Home/NewDashboard.js';
// import Home2 from './pages/HomeVersionTwo/Home2.js';
import Home from './pages/HomeVersionTwo/HomePageVersionTwo';
import LandingPage from './pages/LandingPage/LandingPage.js';
import Login from './pages/Login/Login';
// import HomePage from './pages/PMS Page/pmsHomePage';
// import PmsFileUpload from './pages/PMSFileUpload/PmsFileUpload';
// import Dashboard1 from './pages/AOP copy/aopDummy';

// import CorporateLanding from './pages/LandingPage/CorporateLanding.js';
// Pages other than login, landing and reports are loaded on demand, so the
// report page doesn't have to download and parse every other page's code
// (and its chart/table libraries) before it can start.
const Glossary = lazy(() => import('./components/Glossary/Glossary'));
const AdminNew = lazy(() => import('./pages/Admin/AdminNew'));
const DigitalBuPage = lazy(() => import('./pages/Digital Hub/DigitalBuPage'));
const EmailGenration = lazy(
  () => import('./pages/Digital Hub/Upload Pages/EmailGenration'),
);
const ProVisionAdminPanel = lazy(
  () => import('./pages/Provision/ProVisionAdminPanel'),
);
const FinanceAutomationPortal = lazy(
  () => import('./pages/Finance Automation/FinanceAutomationPortal'),
);
const ProVisionDashboard = lazy(
  () => import('./pages/Provision/feedbackPage/ProVisionDashboard'),
);
const MainUI = lazy(() => import('./pages/BulkUpload/MainUI'));
const PMS_US_App = lazy(() => import('./pages/PMS_US/PMS_US_App.js'));
const ProjectionsRemarks = lazy(
  () => import('./pages/Remarks/ProjectionsRemarks'),
);
const ReportPage = lazy(() => import('./pages/Reports/ReportPage'));
const TwoWayHome = lazy(
  () => import('./pages/TwoWayFormResponse/TwoWayFormResponse'),
);
const UsageMetrics = lazy(() => import('./pages/UsageMetrics/UsageMetrics'));
const UserProfile = lazy(() => import('./pages/UserProfile/UserProfile'));
const AopWrapper = lazy(() => import('./pages/AOP/AopWrapper'));

// Initialise App Insights once. It used to be created inside App(), so every
// re-render (e.g. when the user logs in) added another instance that wrapped
// every network request again, slowing down all API calls.
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: '9d5e64f0-ccad-44d2-a134-083ba92226aa',
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
  },
});
appInsights.loadAppInsights();

function App() {
  let user = useSelector((state) => state.PowerBi.user);
  return (
    <div className='App'>
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path='/' element={<Login />} />
            <Route element={<PrivateRoutes />}>
              <Route path='/Home' element={<LandingPage />} />
              {/* <Route path='/CorporateLanding' element={<CorporateLanding />} /> */}
              <Route
                path='/reports/:groupName?/:reportName?'
                element={<Home />}
              />
              {/* oneData revamp code */}

              {/* <Route
							path='reports/v2'
							element={<Home />}
						/> */}
              {user?.ISADMIN && (
                <Route path='/admin'>
                  <Route path='' element={<AdminNew />} />
                  <Route path='report' element={<ReportPage />} />
                </Route>
              )}
              <Route path='/glossary' element={<Glossary />} />
              <Route path='/usage-metrics' element={<UsageMetrics />} />
              <Route path='form/:uuid/:id' element={<TwoWayHome />} />
              <Route path='/remarks' element={<ProjectionsRemarks />} />
              {/* {(user?.DIGITAL_HUB?.includes('IndustryMesh_view') ||
              user?.DIGITAL_HUB?.includes('IndustryMesh_edit')) && (
              <Route path='/industry_Mapping' element={<IndustryMapping />} />
            )} */}
              {/* <Route
              path='/page2'
              element={<AuroraDashboard></AuroraDashboard>}
            /> */}
              <Route
                path='/calibration-dashboard'
                element={
                  ['Not in use Currenly'].includes(user?.PMS_ACCESS) ? (
                    <UserProfile />
                  ) : (
                    <Home />
                  )
                }
              />
              {/* <Route
              path='/upload'
              element={
                ['hr', 'review_committee'].includes(user?.PMS_ACCESS) ? (
                  <PmsFileUpload />
                ) : (
                  <Home />
                )
              }
            /> */}
              {/* Route for download */}
              {/* <Route
              path='/download'
              element={
                ['hr', 'review_committee'].includes(user?.PMS_ACCESS) ? (
                  <FileList />
                ) : (
                  <Home />
                )
              }
            /> */}

              {/* <Route
              path='/increment-matrix'
              element={
                ['cp', 'vp', 'hr', 'review_committee', 'vp+', 'vp-'].includes(
                  user?.PMS_ACCESS
                ) ? (
                  <IncrementMatrix />
                ) : (
                  <Home />
                )
              }
            /> */}
              {/* <Route
              path='/pms-page'
              element={
                ['cp', 'vp', 'hr', 'review_committee', 'vp+', 'vp-'].includes(
                  user?.PMS_ACCESS
                ) ? (
                  <HomePage />
                ) : (
                  <Home />
                )
              }
            /> */}
              {/* <Route
              path='/pms-analysis'
              element={
                ['cp', 'vp', 'hr', 'review_committee', 'vp+', 'vp-'].includes(
                  user?.PMS_ACCESS
                ) ? (
                  <VPDashboard />
                ) : (
                  <Home />
                )
              }
            />
            {/* <Route path='/empCv' element={<EmployeeCV></EmployeeCV>} /> */}
              {/* {user?.DIGITAL_HUB?.includes('EmployeeCv') && (
              <Route path='/TalentLens' element={<EmployeeCV />} />
            )} */}

              {/* <Route path='/MIS' element={<MISUpload />} /> */}
              <Route
                path='/digital-hub'
                element={<DigitalBuPage></DigitalBuPage>}
              />
              {/* <Route
              path='/email-generator'
              element={<EmailGenration></EmailGenration>}
            /> */}
              {user?.DIGITAL_HUB?.includes('EmailGenerator') && (
                <Route path='/email-generator' element={<EmailGenration />} />
              )}
              {/* <Route
              path='/inc'
              element={
                <EmployeeIncrementDashboard></EmployeeIncrementDashboard>
              }
            /> */}
              {/* <Route path='/PmsUs' element={<PMS_US_App></PMS_US_App>} /> */}
              {user?.DIGITAL_HUB?.includes('PMS') && (
                <Route path='/PmsUs' element={<PMS_US_App />} />
              )}
              {/* <Route path='/PivotReport' element={<DynamicPivotTable />} /> */}
              {/* <Route
              path='/cloud-expense'
              element={<CloudExpenseGenerator></CloudExpenseGenerator>}
            /> */}
              {/* <Route
              path='/timesheet'
              element={<TimesheetAutomationUpload></TimesheetAutomationUpload>}
            /> */}
              <Route
                path='/finance-automation'
                element={<FinanceAutomationPortal></FinanceAutomationPortal>}
              />

              <Route path='/provision-app' element={<ProVisionDashboard />} />

              <Route
                path='/provision-app/admin'
                element={<ProVisionAdminPanel />}
              />

              {user?.ISADMIN && (
                <Route path='/admin-automation' element={<MainUI />} />
              )}

              {/* <Route path='/aop-new' element={<Dashboard1 />} /> */}
              {/* <Route path='/aop' element={<Dashboard />} />
            <Route
              path='/test-aop'
              element={<ProjectionsDashboard></ProjectionsDashboard>}
            /> */}
              {/* 🟢 NEW: Route to the Wrapper instead of AopDashboard directly */}
              <Route path='/aop' element={<AopWrapper />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}
export default App;
